import { useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { quotationActivityShape, quotationErrorShape } from "app/utils/propTypes";
import QuotationActivity from "app/pages/Booking/Quotation/Activity/QuotationActivity/QuotationActivity";
import { ALERT_TYPE } from "app/constants";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import "./QuotationActivities.scss";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const QuotationActivities = ({ activities, onChange, error }) => {
	const { track } = useAnalytics();
	const hasDuplicateDates = error?.duplicateDates?.length > 0;

	// Depends on the boolean, not the array: Formik validation rebuilds `duplicateDates` on every change
	useEffect(() => {
		if (hasDuplicateDates) {
			track("activity_date_error");
		}
	}, [hasDuplicateDates]);

	return (
		<div className="quotation-activities">
			{hasDuplicateDates && (
				<AlertMessage
					alertType={ALERT_TYPE.ERROR}
					message={<FormattedMessage id="quotation.activity.date.duplicate" />}
				/>
			)}
			<div className="quotation-activities__list">
				{activities.map((activity, index) => {
					return (
						<div className="quotation-activities__item" key={activity.code}>
							<QuotationActivity
								index={index}
								onChange={onChange}
								activity={activity}
								error={error}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

QuotationActivities.propTypes = {
	activities: PropTypes.arrayOf(quotationActivityShape),
	onChange: PropTypes.func,
	error: quotationErrorShape,
};

export default QuotationActivities;
